<template>

    <div ref="buttonMagnetic" class="buttonMagnetic" :class="{'buttonMagnetic-minus' : minus}"
            data-reactivesize="60"
            data-ratio="5"
            data-max="40"
            data-scale="1"
            data-ease="0.075">
        <span class="buttonMagnetic_icon" ref="buttonMagnetic_icon"></span>
        <span class="buttonMagnetic_circle"></span>
    </div>

</template>

<script>

    export default {
        name: 'ButtonMagnetic',
        data() {
            return {
                  pauseAnimationFrame: true,
            };
        },
        props: {
            color: {
                type: String,
                default: '#000',
            },
            minus: {
                type: Boolean,
                default: false,
            },
            isWhite: {
                type: Boolean,
                default: false,
            }
        },
        methods: {
            init() {
                this.ui = {
                    btn: this.$refs.buttonMagnetic,
                    label: this.$refs.buttonMagnetic_icon,
                };
                if(this.isWhite == true){
                    Object.assign(this.ui.btn.style, {
                        color: "#ffffff",
                    });
                }else {
                    Object.assign(this.ui.btn.style, {
                        color: this.color,
                    });
                }
                this.initState();
                this.$events.on('ButtonMagneticUpdate', this.initState);
            },
            initState() {
                this.state = {
                    bounds: this.ui.btn.getBoundingClientRect(),
                    reactiveSize: parseInt(this.ui.btn.dataset.reactivesize),
                    ratio: parseInt(this.ui.btn.dataset.ratio),
                    isMagnetic: false,
                    mouse: {
                        x: 0,
                        y: 0,
                    },
                    ease: {
                        x: 0,
                        y: 0,
                        scale: 1,
                        value: this.ui.btn.dataset.ease,
                    },
                    transform: {
                        x: 0,
                        y: 0,
                        scale: 1,
                        max: parseInt(this.ui.btn.dataset.max),
                    },
                    width: window.innerWidth,
                    height: window.innerHeight,
                    history: false,
                    scale: this.ui.btn.dataset.scale,
                };
            },
            isMagnetic(x, y) {
                const { bounds } = this.state;

                const centerX = bounds.left + (bounds.width / 2);
                const centerY = bounds.top + (bounds.height / 2);

                // use pythagorean theorem to calculate
                // cursor distance from center of btn
                // a^2 + b^2 = c^2
                const a = Math.abs(centerX - x);
                const b = Math.abs(centerY - y);
                const c = Math.sqrt(a * a + b * b) * 4;


                // true if cursor distance from center of btn is
                const isHover = c < this.state.reactiveSize;

                if (!this.state.history && isHover) {
                    this.ui.btn.classList.add('is-hover');
                    Object.assign(this.state, {
                        history: true,
                    });
                } else if (this.state.history && !isHover) {
                    this.ui.btn.classList.remove('is-hover');
                    Object.assign(this.state, {
                        history: false,
                    });
                }

                return isHover;
            },
            mouseMove({ pageX, pageY }) {
                Object.assign(this.state, {
                    mouse: {
                        x: pageX,
                        y: pageY,
                    },
                    isMagnetic: this.isMagnetic(pageX, pageY),
                });
            },
            resize() {
                Object.assign(this.state, {
                    bounds: this.ui.btn.getBoundingClientRect(),
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            },
            loop() {
                if (this.pauseAnimationFrame) {
                    return;
                }

                const { bounds, isMagnetic, transform, mouse, width, height, ease, scale } = this.state;

                const centerX = bounds.left + (bounds.width / 2);
                const centerY = bounds.top + (bounds.height / 2);

                let mouseOffSetX = (mouse.x - centerX);
                if (mouseOffSetX < 0) {
                    mouseOffSetX = Math.max(mouseOffSetX, -this.state.transform.max);
                } else {
                    mouseOffSetX = Math.min(mouseOffSetX, this.state.transform.max);
                }


                let mouseOffSetY = (mouse.y - centerY);
                if (mouseOffSetY < 0) {
                    mouseOffSetY = Math.max(mouseOffSetY, -this.state.transform.max);
                } else {
                    mouseOffSetY = Math.min(mouseOffSetY, this.state.transform.max);
                }


                transform.x = isMagnetic ? mouseOffSetX : 0;
                transform.y = isMagnetic ? mouseOffSetY : 0;

                transform.scale = isMagnetic ? scale : 1;

                // basic linear interpolation
                ease.x += (transform.x - ease.x) * ease.value;
                ease.y += (transform.y - ease.y) * ease.value;
                ease.scale += (transform.scale - ease.scale) * ease.value;


                Object.assign(this.ui.btn.style, {
                    transform: `
                        translate(
                            ${ease.x.toFixed(2)}px,
                            ${ease.y.toFixed(2)}px
                        )
                        translateZ(0)
                        scale(
                            ${(ease.scale).toFixed(2)}
                        )`,
                });

                Object.assign(this.ui.label.style, {
                    transform: `
                        translate(
                            ${(-ease.x  / this.state.ratio).toFixed(2)}px,
                            ${(-ease.y  / this.state.ratio).toFixed(2)}px
                        )
                        translateZ(0)
                        scale(
                            ${(1 / ease.scale).toFixed(2)}
                        )`,
                });



                window.requestAnimationFrame(this.loop);
            },
        },
        mounted: function() {
            this.init();
            document.addEventListener('mousemove', this.mouseMove);
            window.addEventListener('resize', this.resize);
            this.pauseAnimationFrame = false;
            this.loop();
            // this._interval = setInterval(() => {this.init()}, 3000);
        },
        updated: function(){
          //console.debug('updated') ;
        },
        destroyed: function() {
            document.removeEventListener('mousemove', this.mouseMove);
            window.removeEventListener('resize', this.resize);
            this.pauseAnimationFrame = true;
        },
    };
</script>

<style scoped lang="scss">

    $buttonSize: 36px;
    $borderSize: 2px;


    .buttonMagnetic {
        width: $buttonSize;
        height: $buttonSize;
        position: relative;
        color: #fff;
        cursor: pointer;

        &_circle{
            display: inline-block;
            border: $borderSize solid currentColor;
            border-radius: 50%;
            z-index: -1;
            // opacity: 0.2;
            // transition: opacity 0.6s cubic-bezier(0.23, 1, 0.32, 1);
            will-change: opacity;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }

        &_icon{
            display: inline-block;
            user-select: none;
            position: absolute;
            left: 50%;
            top: 50%;
            width: calc(#{$buttonSize} / 2);
            height: calc(#{$buttonSize} / 2);
            margin-left: -$buttonSize / 4;
            margin-top: -$buttonSize / 4;

            &:before,
            &:after{
                width: 100%;
                height: $borderSize;
                display: block;
                content: '';
                background-color: currentColor;
                position: absolute;
                top: 50%;
                left: 0;
                @include transition();
            }
            &:after{
                transform: rotate(90deg);
            }
        }

        &-minus{
            .buttonMagnetic_icon{
                &:after{
                    transform: rotate(180deg);
                }
            }
        }
    }



</style>